<template>
  <transition name="slide-up">
    <div
      v-if="show"
      class="info-panel"
      :style="cssVars"
    >
      <div class="info-panel-inner">
        <div class="info-panel-wrapper">
          <div class="info-panel-outer-body">
            <div class="left-content">
              <div class="left-content-navigation-block">
                <ArrowButtonNavigation
                  @click="handleBackNavigationClick"
                />
              </div>
              <slot name="left-content" />
            </div>
            <div class="main-content">
              <div class="main-content-wrapper">
                <div class="main-content-offset">
                  <div class="main-content-offset-wrapper">
                    <div class="main-content-offset-inner-wrapper">
                      <div class="main-content-offset-inner-wrapper-content">
                        <div
                          v-if="isLoading"
                          class="loading-container"
                        >
                          <SpinnerContainer
                            :is-loading="isLoading"
                          />
                        </div>
                        <slot
                          v-else
                          name="main-content"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import SpinnerContainer from 'components/Loaders/SpinnerContainer';
  import ArrowButtonNavigation from 'components/InfoPanel/ArrowButtonNavigation';

  export default {
    name: 'InfoPanel',
    components: {
      SpinnerContainer,
      ArrowButtonNavigation
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      duration: {
        type: Number,
        default: 400
      },
      backgroundColor: {
        type: String,
        default: '#fff'
      },
      isLoading: {
        type: Boolean,
        default: false
      },
      headerSelector: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        headerHeight: 0
      };
    },
    computed: {
      cssVars () {
        return {
          '--animation-duration': `${this.duration}ms`,
          '--background-color': this.backgroundColor,
          '--header-height': `${this.headerHeight}px`
        };
      }
    },
    watch: {
      show (newVal) {
        if (newVal) {
          this.updateHeaderHeight();
        }
      }
    },
    mounted () {
      if (this.headerSelector) {
        this.updateHeaderHeight();
        window.addEventListener('resize', this.updateHeaderHeight);
      }
    },
    beforeDestroy () {
      if (this.headerSelector) {
        window.removeEventListener('resize', this.updateHeaderHeight);
      }
    },
    methods: {
      handleBackNavigationClick () {
        this.$emit('back-navigation-click');
      },
      updateHeaderHeight () {
        const headerElement = document.querySelector(this.headerSelector);
        if (!headerElement) {
          this.headerHeight = 0;
          return;
        }

        this.headerHeight = headerElement.offsetHeight;
      }
    }
  };
</script>

<style scoped>
  @keyframes slide-up-in {
    from {
      transform: translate3d(0, 100%, 0);
    }

    to {
      transform: translate3d(0, 0%, 0);
    }
  }

  @keyframes slide-up-out {
    from {
      transform: translate3d(0, 0%, 0);
    }

    to {
      transform: translate3d(0, 100%, 0);
    }
  }

  .info-panel {
    --padding-top: 30px;
    --padding-right-left: 20px;

    position: fixed;
    top: var(--header-height, 0);
    bottom: 0;
    left: 0;
    z-index: var(--z-index, 10);

    width: 100%;
  }

  .slide-up-enter-active {
    animation: slide-up-in var(--animation-duration) cubic-bezier(0.25, 1, 0.25, 1);
  }

  .slide-up-leave-active {
    animation: slide-up-out var(--animation-duration) cubic-bezier(0.25, 1, 0.25, 1);
  }

  /* нужно, чтобы блок transition правильно работал */
  .slide-up-enter-from,
  .slide-up-enter-to,
  .slide-up-leave-from,
  .slide-up-leave-to {
    /* stylelint-disable block-no-empty, block-closing-brace-space-after */
  }

  .info-panel-inner {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    background-color: var(--background-color);
  }

  .info-panel-wrapper {
    position: relative;
    display: flex;

    flex-direction: column;
    justify-content: space-between;

    max-width: 1880px;
    height: 100%;

    margin: 0 auto;
    -webkit-box-pack: justify;
  }

  .info-panel-outer-body {
    overflow: hidden;

    position: relative;
    display: flex;

    flex-wrap: nowrap;
    justify-content: space-between;

    height: 100%;
    -webkit-box-pack: justify;
  }

  .left-content {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;

    width: 280px;
    min-width: 280px;
    height: 100%;

    padding: var(--padding-top) var(--padding-right-left);
  }

  .left-content-navigation-block {
    padding-bottom: 10px;
    margin-bottom: 35px;
  }

  .main-content {
    position: relative;

    width: 100%;
    height: 100%;
  }

  .main-content-wrapper {
    overflow: hidden;

    width: inherit;
    max-width: inherit;
    height: inherit;
    max-height: inherit;
  }

  .main-content-offset {
    position: absolute;
    right: 0;
    bottom: 0;

    padding: 0;

    margin: 0;
    resize: none;

    direction: inherit;
    inset: 0;
  }

  .main-content-offset-wrapper {
    overflow: hidden auto;

    position: relative;
    display: block;

    width: auto;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    min-height: 100%;

    direction: inherit;
  }

  .main-content-offset-inner {
    height: auto;

    padding-bottom: 0;
    padding-right: 0;
  }

  .main-content-offset-inner-wrapper {
    position: relative;
    display: flex;

    flex-wrap: nowrap;
    justify-content: space-between;

    height: 100%;
    -webkit-box-pack: justify;
  }

  .main-content-offset-inner-wrapper-content {
    position: relative;

    flex-basis: 720px;

    width: 100%;
    max-width: 720px;
    height: 100%;

    padding: var(--padding-top) 0;

    margin: 0 auto;
  }

  .loading-container {
    height: 100%;
    margin: auto;
  }
</style>
